import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useInView } from "react-intersection-observer";
import CountUp from "react-countup";
import { Box, Grid, Card, Typography, Container, useMediaQuery } from "@mui/material";

const stats = [
  {
    icon: require("../../assets/Animated/Home/contract.gif"),
    end: 4,
    suffix: " Million +",
    label: "Satisfied Customers",
  },
  {
    icon: require("../../assets/Animated/Home/ClaimSettlements.gif"),
    end: 1,
    suffix: " Million +",
    label: "Claim Settlements",
  },
  {
    icon: require("../../assets/Animated/Home/Rating.gif"),
    end: 4.5,
    suffix: "/5",
    label: "Rating",
  },
  {
    icon: require("../../assets/Animated/Home/Associates.gif"),
    end: 100,
    suffix: "+",
    label: "Leading Clients",
  },
  {
    icon: require("../../assets/Animated/Home/PinCodeServed.gif"),
    end: 18000,
    suffix: "+",
    label: "Pincode Served",
  },
  {
    icon: require("../../assets/Animated/Home/world-population.gif"),
    end: 190,
    suffix: "+",
    label: "Global Network",
  },
  {
    icon: require("../../assets/Animated/Home/EmployeeNPS.gif"),
    end: 95,
    suffix: "+",
    label: "Employees NPS",
  },
  {
    icon: require("../../assets/Animated/Home/LeadingCLients.gif"),
    end: 2500,
    suffix: "+",
    label: "Associates",
  },
];

const FastestGrowing = () => {
  const { ref, inView } = useInView({
    threshold: 0.2,
    triggerOnce: true,
  });

  // Check for mobile view
  const isMobile = useMediaQuery("(max-width:899px)");

  // Animation variants for cards
  const cardVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: (index) => ({
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        delay: index * 0.15,
        ease: "easeOut",
      },
    }),
  };

  return (
    <Box
      textAlign="center "
      sx={{
        background: "#fff6f1",
        py: 4,
        px: {
          xs: 2,
        },
      }}
    >
      <Typography variant="h4" mt={1} className="main-heading-font-size">
        The Fastest Growing Assurance Company in India
      </Typography>
      <Typography variant="h6">
        Partner with Across Assist to drive unparalleled growth and set new
        standards in customer satisfaction.
      </Typography>
      <Box sx={styles.root}>
        <Container maxWidth="lg" disableGutters sx={{ py: 2 }}>
          {/* <Heading title={getMeaning("HME.FSTSTGRWNG")} /> */}
          <Box
            textAlign="center"
            mt={{ xs: "1.2rem", sm: "1.2rem", md: "0.01px" }}
          >
            {/* <GlobalSubHeading subTitle={getMeaning("HME.FSTSTGRWNGDESCP")} /> */}
          </Box>

          <Grid
            ref={ref}
            container
            spacing={2}
            justifyContent="center"
            // For mobile, force 2 columns, otherwise keep 4 columns for desktop/tablet
            columns={isMobile ? 2 : 12}
          >
            <AnimatePresence>
              {inView &&
                stats.map((stat, index) => (
                  <Grid
                    item
                    xs={isMobile ? 1 : 3}
                    sm={isMobile ? 1 : 3}
                    md={3}
                    key={index}
                  >
                    <motion.div
                      custom={index}
                      initial="hidden"
                      animate="visible"
                      variants={cardVariants}
                    >
                      <Card
                        sx={{
                          height: "100%",
                          width: { xs: 160, sm: 230, md: 280, lg: 240 },
                          textAlign: "center",
                          borderRadius: 3,
                          boxShadow: "none",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          p: 2.5,
                          background: "#fff6f1",
                          transition: "all 0.3s ease",
                          "&:hover": {
                            background: "white",
                            border: "1px solid #fe7c0b",
                            boxShadow: "1px 2px 10px 2px rgba(0,0,0,0.1)",
                            color: "white",
                            transform: "translateY(-5px)",
                          },
                        }}
                      >
                        <Box
                          sx={{
                            mb: 0,
                            borderRadius: "50%",
                            width: 90,
                            height: 90,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <img
                            src={stat.icon}
                            className="gif-color-change"
                            alt="stats icon"
                            style={{
                              width: 82,
                              height: 82,
                              borderRadius: "50%",
                            }}
                          />
                        </Box>

                        <Typography
                          variant="h5"
                          fontWeight={500}
                          sx={{
                            color: "black",
                            marginLeft: "10px",
                            fontSize: {
                              xs: "1.05rem",
                              sm: "1.25rem",
                              md: "1.2rem",
                              lg: "1.3rem",
                            },
                            fontFamily: '"Poppins", serif',
                          }}
                        >
                          <CountUp
                            start={0}
                            end={stat.end}
                            duration={2.5}
                            separator=","
                            decimals={stat.end % 1 !== 0 ? 1 : 0}
                          />
                          {stat.suffix}
                        </Typography>

                        <Typography
                          color="textSecondary"
                          sx={{
                            color: "#585a5c",
                            mt: 0.1,
                            fontSize: "0.95rem",
                          }}
                        >
                          {stat.label}
                        </Typography>
                      </Card>
                    </motion.div>
                  </Grid>
                ))}
            </AnimatePresence>
          </Grid>
        </Container>
      </Box>
    </Box>
  );
};

export default FastestGrowing;

const styles = {
  root: {
    textAlign: "center",
    // background: "#fff6f1",
  },
};
